'use client';

interface AirlineInfoSectionProps {
  airlineSlug: string;
  airlineName: string;
  feature?: string;
  seat?: string;
  dining?: string;
  whyChooseTitle?: string;
}

const AirlineInfoSection = ({ airlineSlug, airlineName, feature, seat, dining, whyChooseTitle }: AirlineInfoSectionProps) => {
  // Debug logging
  console.log('AirlineInfoSection props:', { airlineSlug, airlineName, feature, seat, dining, whyChooseTitle });
  
  // If no content is provided, don't render the section
  if (!feature && !seat && !dining) {
    console.log('No content provided for AirlineInfoSection, not rendering');
    return null;
  }

  const cards = [
    {
      title: 'Features',
      description: feature || 'Premium features and amenities for your comfort.',
      bgColor: 'bg-[#0ABAB5]'
    },
    {
      title: 'Seat',
      description: seat || 'Comfortable seating with modern amenities.',
      bgColor: 'bg-[#0ABAB5]'
    },
    {
      title: 'Dining',
      description: dining || 'Exceptional dining experience with premium cuisine.',
      bgColor: 'bg-[#0ABAB5]'
    }
  ];

  console.log('Rendering AirlineInfoSection with cards:', cards);

  // Use custom title if provided, otherwise use default
  const sectionTitle = whyChooseTitle || `Why Choose ${airlineName}?`;

  return (
    <section className="max-w-[1280px] mx-auto px-2 pb-4 sm:pb-10">
      <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 text-center mb-8">{sectionTitle}</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6">
        {cards.map((card, index) => (
          <div key={index} className={`rounded-2xl ${card.bgColor} p-6 text-white text-center`}>
            <h4 className="text-lg font-semibold">{card.title}</h4>
            <p className="mt-2 text-sm leading-relaxed">{card.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AirlineInfoSection;